import React = require('react');
import { Button } from 'react-bootstrap';
import { FaSpinner } from 'react-icons/fa';

interface IMakeAChangeRedirectButtonProps {
  calculating: boolean;
  route: string;
  push: (route: string) => void;
}

export const MakeAChangeRedirectButton = ({ calculating, route, push }: IMakeAChangeRedirectButtonProps) => {

  if (!route) {
    return;
  }

  const handleOnClick = () => {
    push(route);
  }

  return (
    <Button
      bsStyle="primary"
      type="button"
      bsSize="small"
      block={true}
      className={'functional-button'}
      onClick={handleOnClick}
      disabled={calculating}>
      {calculating && (
        <FaSpinner className="fa-spin"/>
      )}
      MAKE CHANGES TO MY COVER
    </Button>
  )
}
